import {useNavigate} from 'react-router-dom';
import {
    FlexiCancelButton
} from "@flexinet/ui-components";
import {AiOutlineEdit} from "react-icons/ai";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {EditButton} from "../buttons/EditButton.tsx";
import {DownloadButton} from "../buttons/DownloadButton.tsx";
import {RetakeButton} from "../buttons/RetakeButton.tsx";
import config from "../config";

export const useEditPageTools = () => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const tools = [];

    if (allowedActions.includes(rbacActions.UpdateApplicationScreenshot)) {
        tools.push(<EditButton leftSection={<AiOutlineEdit/>} variant={'filled'}
                               key={'edit'}>Edit</EditButton>);
    }

    // Retake re-runs the capture and overwrites the stored image, so it is gated on
    // its own action rather than rendered to anyone who can open the page (FNP-1353).
    if (allowedActions.includes(rbacActions.RetakeApplicationScreenshot)) {
        tools.push(<RetakeButton key={'retake'}/>);
    }

    if (allowedActions.includes(rbacActions.GetApplicationScreenshot)) {
        tools.push(<DownloadButton key={'download'}/>);
    }

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(config.basePath)}/>);


    return {
        tools,
    };

};
